import * as XLSX from "xlsx-js-style";

const DAYS = [
  { key: "bshMonday",    label: "Lun" },
  { key: "bshTuesday",   label: "Mar" },
  { key: "bshWednesday", label: "Mié" },
  { key: "bshThursday",  label: "Jue" },
  { key: "bshFriday",    label: "Vie" },
  { key: "bshSaturday",  label: "Sáb" },
  { key: "bshSunday",    label: "Dom" },
];

const HEADERS = ["busId", "Nombre", "Placa", "Línea", "Ruta", "Ciudad", ...DAYS.map((d) => d.label)];

export function exportBusScheduleTemplate(buses, schedulesByBusId, filename = "plantilla_horarios_buses.xlsx") {
  const rows = buses.map((bus) => {
    const sched = schedulesByBusId.get(bus.id) || {};
    return {
      busId: bus.id,
      Nombre: bus.name || "",
      Placa: bus.plate || "",
      Línea: bus.brand || "",
      Ruta: bus.route || "",
      Ciudad: bus.city || "",
      Lun: sched.bshMonday    ? "X" : "",
      Mar: sched.bshTuesday   ? "X" : "",
      "Mié": sched.bshWednesday ? "X" : "",
      Jue: sched.bshThursday  ? "X" : "",
      Vie: sched.bshFriday    ? "X" : "",
      "Sáb": sched.bshSaturday  ? "X" : "",
      Dom: sched.bshSunday    ? "X" : "",
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(rows, { header: HEADERS });

  const headerStyle = {
    font: { bold: true, color: { rgb: "FFFFFFFF" } },
    fill: { patternType: "solid", fgColor: { rgb: "FF2E335B" } },
    alignment: { horizontal: "center", vertical: "center" },
  };

  HEADERS.forEach((_, idx) => {
    const cellAddr = XLSX.utils.encode_cell({ r: 0, c: idx });
    if (worksheet[cellAddr]) worksheet[cellAddr].s = headerStyle;
  });

  worksheet["!cols"] = [
    { wch: 8 },   // busId
    { wch: 24 },  // Nombre
    { wch: 12 },  // Placa
    { wch: 28 },  // Línea
    { wch: 28 },  // Ruta
    { wch: 18 },  // Ciudad
    ...DAYS.map(() => ({ wch: 6 })),
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Horarios");
  XLSX.writeFile(workbook, filename);
}

export async function parseBusScheduleExcel(file) {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: "array" });
  const sheetName = workbook.SheetNames[0];
  const sheet = workbook.Sheets[sheetName];
  const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });

  const isMark = (v) => {
    if (v == null) return false;
    const s = String(v).trim().toLowerCase();
    return s === "x" || s === "1" || s === "true" || s === "sí" || s === "si";
  };

  const dtos = [];
  const errors = [];

  rows.forEach((row, idx) => {
    const busId = Number(row.busId ?? row.BusId ?? row.BUSID);
    if (!busId || Number.isNaN(busId)) {
      errors.push(`Fila ${idx + 2}: busId inválido o ausente.`);
      return;
    }
    dtos.push({
      busId,
      bshMonday:    isMark(row.Lun),
      bshTuesday:   isMark(row.Mar),
      bshWednesday: isMark(row["Mié"] ?? row.Mie),
      bshThursday:  isMark(row.Jue),
      bshFriday:    isMark(row.Vie),
      bshSaturday:  isMark(row["Sáb"] ?? row.Sab),
      bshSunday:    isMark(row.Dom),
    });
  });

  return { dtos, errors };
}
